var e = function(e) {
        var s;
        this.element = e, this.headerRows = this.element.getElementsByTagName("thead")[0].getElementsByTagName("th"), this.tableRows = this.element.getElementsByTagName("tbody")[0].getElementsByTagName("tr"), this.collapsedLayoutClass = "row-table--collapsed", this.mainRowCellClass = "row-table__th-inner", t(s = this),
            function(e) {
                for (var t = 0; t < e.tableRows.length; t++) {
                    for (var i = "", s = e.tableRows[t].getElementsByClassName("row-table__cell"), n = 0; n < s.length; n++)
                        if (n > 0) {
                            Util.addClass(s[n], ".js-" + e.mainRowCellClass);
                            var a = s[n].getElementsByClassName("row-table__th-inner");
                            //a.length > 0 && (a[0].innerHTML = a[0].innerHTML + '<i class="row-table__th-icon" aria-hidden="true"></i>')
                        } else 
                           i = i +'<li class="row-table__item"><span class="row-table__label">' + e.headerRows[n].innerHTML + ":</span><span>" + s[n].innerHTML + "</span></li>";
                    //i = '<ul class="row-table__list" aria-hidden="true">' + i + "</ul>", s[0].innerHTML = '<input type="text" class="row-table__input" aria-hidden="true">' + s[0].innerHTML + i
                }
                 
            }(s), s.element.addEventListener("update-row-table", (function(e) {
                t(s)
            })), s.element.addEventListener("click", (function(e) {
                i(s, e)
            })), s.element.addEventListener("keydown", (function(e) {
                (e.keyCode && 13 == e.keyCode || e.key && "enter" == e.key.toLowerCase()) && i(s, e)
            }))
    };

    function t(e) {
        var t = getComputedStyle(e.element, ":before").getPropertyValue("content").replace(/\'|"/g, "");
        Util.toggleClass(e.element, e.collapsedLayoutClass, "expanded" == t)
    
    }

   function i(e, t) {
        if (t.target.closest(".js-" + e.mainRowCellClass) && !t.target.closest(".row-table__list")) {
            var i = t.target.closest(".js-" + e.mainRowCellClass);
            Util.toggleClass(i, "row-table__cell--show-list", !Util.hasClass(i, "row-table__cell--show-list"))
        }
  
    }

    var s = document.getElementsByClassName("js-row-table");  
    if (s.length > 0) {
        for (var n = 0, a = [], r = 0; r < s.length; r++) {
            var o = getComputedStyle(s[r], ":before").getPropertyValue("content");
            o && "" != o && "none" != 0 && ( function(t) {
                a.push(new e(s[t]))
            }(r), n += 1)
        }
        if (n > 0) {
         
            var l = 0,
                d = new CustomEvent("update-row-table");

            function h() {
                for (var e = 0; e < a.length; e++) ! function(e) {
                    a[e].element.dispatchEvent(d)
                }(e)
            }
            window.addEventListener("resize", (function(e) {
                clearTimeout(l), l = setTimeout(h, 300)
            })), window.requestAnimationFrame ? window.requestAnimationFrame(h) : h()
        }
        
    }
